import $ from 'jquery';
import $Form from './forms';

$(() => {
  const form = $('.recaptcha-form'),
    submitBtn = form.find('input[type=submit]');

  if (form.length) {
    form.on('custom-validation', function (e, noOfErrors) {
      if (noOfErrors === 0) {
        $Form.disableButton(submitBtn);
        try {
          grecaptcha.execute();
        } catch (error) {
          $Form.finishValidation(form);
          $Form.renableButton(submitBtn);
          throw error;
        }
      } else {
        form.trigger('custom-validation-callback', [noOfErrors]);
      }
    });

    window.submitInvisibleRecaptchaForm = function () {
      $Form.finishValidation(form);
      $Form.disableButton(submitBtn);
      $Form.submitForm(form, submitBtn);
    };
  }
});
